module.exports = __webpack_public_path__ + "img/big-dupa.fd513534.png";